import { Component, Input } from '@angular/core';
import { CNAEViewer } from '../../adapters/cnae-viewer.interface';

@Component({
    selector: 'sgt-cnae-table-view',
    templateUrl: './cnae-table-view.component.html',
    styleUrls: ['./cnae-table-view.component.less']
})
export class CNAETableViewComponent {
    @Input() isShowIndicadores: boolean;
    @Input() cnaes: CNAEViewer[];
    @Input() emptyText = 'Nenhuma CNAE encontrada';
}
